import {ErrorMessage} from 'angular-error-repository';

export const requiredError: ErrorMessage = () => {
    return 'Please fill in this field';
};
